<script lang="ts" setup>
import { randomUuid } from '#layers/base/public';
import { useWorkspaceEntityStore } from '#layers/runtime/public';
import { getSpaceNextSortValue } from '#layers/spaces/utils/space';

const { spaceId } = defineProps<{
	spaceId: string;
}>();

const emit = defineEmits<{
	close: [];
}>();

const store = useWorkspaceEntityStore();

const id = randomUuid();

// eslint-disable-next-line vue/no-setup-props-reactivity-loss -- reads the space this instance was opened for
const space = store.MonospaceSpace.peekFirst(spaceId);

if (!space) {
	throw new Error('Space not found');
}

const createPageSection = store.MonospacePageSection.createForm({
	defaultValues: () => ({
		id,
		title: '',
		sort: getSpaceNextSortValue(space),
		spaceId,
	}),
});

createPageSection.$onSuccess(() => {
	emit('close');
});
</script>

<template>
	<DDialog :title="$t('page_section.add.title')">
		<template #body>
			<DForm
				id="page-section-create-form"
				:state="createPageSection"
				:schema="createPageSection.$schema"
				layout="side-by-side"
				auto-focus-first-input
				:validate-on="[]"
				@submit="createPageSection.$submit()"
			>
				<DFormField
					name="title"
					:label="$t('page_section.title')"
				>
					<DInput
						v-model="createPageSection.title"
						:placeholder="$t('page_section.title_placeholder')"
					/>
				</DFormField>
			</DForm>
		</template>

		<template #footer>
			<DButton
				:label="$t('common.cancel')"
				color="neutral"
				variant="outline"
				size="sm"
				@click="emit('close')"
			/>

			<DButton
				type="submit"
				form="page-section-create-form"
				:label="$t('page_section.add.submit')"
				size="sm"
			/>
		</template>
	</DDialog>
</template>
